import './SliderCursos.css'

function SliderCursos() {
  return (
<div className="logos">
  <div className="logos-slide">
    <img src="./Cursos/logo-web-1@2x.png" />
    <img src="./Cursos/sustain-1@2x.png" />
   
  </div>
  <div className="logos-slide">
    <img src="./Cursos/logo-web-1@2x.png" />
    <img src="./Cursos/sustain-1@2x.png" />
  </div>
  <div className="logos-slide">
    <img src="./Cursos/logo-web-1@2x.png" />
    <img src="./Cursos/sustain-1@2x.png" />
  </div>
  <div className="logos-slide">
    <img src="./Cursos/logo-web-1@2x.png" />
    <img src="./Cursos/sustain-1@2x.png" />
  </div>
  <div className="logos-slide">
    <img src="./Cursos/logo-web-1@2x.png" />
    <img src="./Cursos/sustain-1@2x.png" />
  </div>
</div>

  );
}

export default SliderCursos;
